<template>
  <v-chart :option="option" autoresize style="width:100%;height:100%;" />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import VChart from 'vue-echarts';
import { useChartTheme } from '@/composables/useChartTheme';

const props = defineProps<{ soh: number }>();

const option = computed(() => {
  const C = useChartTheme();
  const remainder = Math.max(0, 100 - props.soh);
  return {
    backgroundColor: 'transparent',
    series: [{
      type: 'pie',
      radius: ['52%', '82%'],
      center: ['50%', '50%'],
      avoidLabelOverlap: false,
      label: { show: false },
      emphasis: { label: { show: false }, scale: false },
      data: [
        { value: props.soh, itemStyle: { color: C.good } },
        { value: remainder,  itemStyle: { color: C.line } },
      ],
    }],
  };
});
</script>
